
export class Usuario {

  user: String;
  senha: string;
  nome: String;

}
